import axios, { AxiosInstance } from 'axios'

const hostname = window.location.hostname;
// Match the last two segments (e.g., procricket.tv from stage.procricket.tv)
const rootDomain = hostname.replace(/^.*?([^.]+\.[^.]+)$/, '$1');
// Use the VUE_APP_API_URL as a template e.g. "https://api.rootDomainPlaceholder"
const rawApiUrl = process.env.VUE_APP_API_URL;
// Replace the placeholder manually
const apiBaseUrl = rawApiUrl.replace('rootDomainPlaceholder', rootDomain);

const apiClient: AxiosInstance = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

export default apiClient
